import { Body, Box, Heading, Image, Sheet, VStack } from '@hover/blueprint';
import React from 'react';
import QRCode from 'react-qr-code';
import { useParams } from 'react-router';

import { getDeepLink } from 'src/modules/homeownerApp/constants/scans';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import appStore from 'assets/img/homeownerApp/download/app-store.png';
import hoverDownload from 'assets/img/homeownerApp/download/hover-download.png';

const IMAGE_SIZE = '660px';

export const DownloadApp = () => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const { projectId } = useParams<{ projectId: string }>();
  const deepLink = getDeepLink(projectId);

  return (
    <Sheet.Contents maxHeight="100vh" overflowY="auto">
      <VStack
        alignItems="flex-start"
        maxW={{ base: 'unset', tablet: IMAGE_SIZE }}
        pb={{
          base: 'calc(var(--motion-overflow) + var(--hover-space-600))',
          tablet: 1000,
        }}
        position="relative"
        pt={{ base: 600, tablet: 1000 }}
        px={{ base: 500, tablet: 1000 }}
      >
        <Image alt="hover download" maxW={IMAGE_SIZE} src={hoverDownload} />
        <Box justifyContent="space-between" pt={600} w="100%">
          <VStack alignItems="flex-start" pt={400}>
            <Heading m={0} mb={200} size={700}>
              {t('projects.download.header')}
            </Heading>
            <Body color="neutral.600" maxW="300px" size={300}>
              {t('projects.download.description')}
            </Body>
            <Box gap={300} pt={400}>
              <Image alt="app store" src={appStore} w="131px" />
            </Box>
          </VStack>
          <Box backgroundColor="neutral.50" borderRadius={400} p={700}>
            <QRCode size={120} value={deepLink} />
          </Box>
        </Box>
      </VStack>
    </Sheet.Contents>
  );
};
